import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { Alert, Box, Typography } from '@mui/material';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import { EmptySectionMessage, FullPageLoader } from '@tassomutuo-backoffice/ui';
import { getLeadsClosed } from '../../services/api/lead/lead';
import LeadCardList from './components/LeadCardList';
import { LeadProductChip } from '../../components';

const LeadsClosedPage = () => {
  const { isPending, data, error } = useQuery({
    queryKey: ['leadsClosed'],
    queryFn: getLeadsClosed,
  });

  const leadsClosed = data?.results;

  return (
    <>
      <FullPageLoader show={isPending} />
      <Box>
        <Box px={4} pt={4} pb={2} display="flex" alignItems="center" gap={1} flexWrap="wrap">
          <EmojiEventsIcon fontSize="large" />
          <Typography variant="h4" fontWeight="bold">
            Lead Vinte
          </Typography>
          <LeadProductChip product="mutui" />
        </Box>

        {!isPending && error && (
          <Alert severity="error">
            {error.message ? `Error: ${error.message}` : 'An Error occurred'}
          </Alert>
        )}
        {leadsClosed &&
          leadsClosed.map((lead) => <LeadCardList key={lead.id} lead={lead} />)}

        {leadsClosed && leadsClosed.length === 0 && (
          <EmptySectionMessage title="Non ci sono lead da mostrare" />
        )}
      </Box>
    </>
  );
};

export default LeadsClosedPage;
